<template>
    <div style="padding: 0px 10px">
      <div class="newsTypeRow" v-if="showTypeRow">
        <div :class="newsType == '交易记录' ? 'newsTypeItemActive':'newsTypeItem'" @click="switchNewsType('交易记录')">
          <pt-icon class="typeIcon" :type="newsType == '交易记录' ? 'icon-jiaoyicopy':'icon-jiaoyijilu1'"></pt-icon>
          <div class="newsTypeText">{{$t('news.newsType.交易记录')}}</div>
          <div class="activeTypeLine"></div>
        </div>
        <div :class="newsType == '同行信息' ? 'newsTypeItemActive':'newsTypeItem'"  @click="switchNewsType('同行信息')">
          <pt-icon class="typeIcon" :type="newsType == '同行信息' ? 'icon-tonghangrenyuancopy':'icon-tonghangxinxi1'"></pt-icon>
          <div class="newsTypeText">{{$t('news.newsType.同行信息')}}</div>
          <div class="activeTypeLine"></div>
        </div>
        <div :class="newsType == '业主动态' ? 'newsTypeItemActive':'newsTypeItem'"  @click="switchNewsType('业主动态')">
          <pt-icon class="typeIcon" :type="newsType == '业主动态' ?'icon-yezhutouxiangcopy':'icon-yezhudongtai1'"></pt-icon>
          <div class="newsTypeText">{{$t('news.newsType.业主动态')}}</div>
          <div class="activeTypeLine"></div>
        </div>
        <div :class="newsType == '租户动态' ? 'newsTypeItemActive':'newsTypeItem'"  @click="switchNewsType('租户动态')">
          <pt-icon class="typeIcon" :type="newsType == '租户动态' ? 'icon-zuhucopy':'icon-zuhuxinxi'"></pt-icon>
          <div class="newsTypeText">{{$t('news.newsType.租户动态')}}</div>
          <div class="activeTypeLine"></div>
        </div>
        <div :class="newsType == '宏观动态' ? 'newsTypeItemActive':'newsTypeItem'"  @click="switchNewsType('宏观动态')">
          <pt-icon class="typeIcon" :type="newsType == '宏观动态' ? 'icon-fenzu1':'icon-hongguandongtai'"></pt-icon>
          <div class="newsTypeText">{{$t('news.newsType.宏观动态')}}</div>
          <div class="activeTypeLine"></div>
        </div>
        <div :class="newsType == '人员变动' ? 'newsTypeItemActive':'newsTypeItem'"  @click="switchNewsType('人员变动')">
          <pt-icon class="typeIcon" :type="newsType == '人员变动' ? 'icon-fenzu':'icon-renyuanbiandong1'"></pt-icon>
          <div class="newsTypeText">{{$t('news.newsType.人员变动')}}</div>
          <div class="activeTypeLine"></div>
        </div>

        <div :class="[newsType == '市场洞察' ? 'newsTypeItemActive':'newsTypeItem',city == 'HK'?'':'lastItem']"  @click="switchNewsType('市场洞察')">
          <pt-icon class="typeIcon" :type="newsType == '市场洞察' ? 'icon-shichangdongcha-lan':'icon-shichangdongcha-hui'"></pt-icon>
          <div class="newsTypeText">{{$t('news.newsType.市场洞察')}}</div>
          <div class="activeTypeLine"></div>
        </div>
        <div class="lastItem" v-if="city == 'HK'" :class="newsType == '住宅' ? 'newsTypeItemActive':'newsTypeItem'"  @click="switchNewsType('住宅')">
          <pt-icon class="typeIcon" :type="newsType == '住宅' ? 'icon-zhuzhaidongtai':'icon-zhuzhaidongtai-hui'"></pt-icon>
          <div class="newsTypeText">{{$t('news.newsType.住宅')}}</div>
          <div class="activeTypeLine"></div>
        </div>

<!--        <div class="citySwitch">-->
<!--          <pt-icon class="cityIcon" type="icon-ditu"></pt-icon>-->
<!--          <pt-select v-model="city" style="width: 80px;" :allowClear="false">-->
<!--            <a-select-option v-for="c in cityDatas" :key="c.wordKey" :value="c.wordKey">{{c.wordValue}}</a-select-option>-->
<!--          </pt-select>-->
<!--        </div>-->
      </div>
      <div class="formDiv" v-if="newsType == '交易记录'">
        <!--交易记录表单-->
        <news-lease-form :is-news-amendment="isNewsAmendment" ref="dealFormRef" :city="value ? value.city :city" :newsDO="value" :mansion-list="mansionList"
                         :defaultRentUnit="defaultRentUnit" :defaultAreaUnit="defaultAreaUnit"
        ></news-lease-form>
      </div>
      <div class="smallFormDiv" v-if="newsType == '同行信息'">
        <a-form :form="peerForm" layout="vertical">
          <a-row :gutter="20">
            <a-col :span="16">
              <a-form-item :label="$t('news.peerForm.companyLabel')" class="required">
                <a-select :placeholder="$t('news.peerForm.companyTip')" show-search optionFilterProp="label" v-decorator="decorators.colleagueId" @change="refreshLinkmanList">
                  <a-icon slot="suffixIcon" type="caret-down" />
                  <div slot="dropdownRender" slot-scope="menu">
                    <v-nodes :vnodes="menu" />
                    <a-divider style="margin: 0;" />
                    <div class="addBottomBtn" @click="openAddColleagueModal">
                      <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                      <div class="addBtnText">{{$t('competePerson.addModal.title')}}</div>
                    </div>
                  </div>
                  <a-select-option v-for="c in colleagueList" :key="c.id" :value="c.id" :label="c.companySortNameCn+'-'+c.companyName" :disabled="!c.selectable">
                    <div style="display:flex;">
                      <div style="flex:1;" class="invisible-item">
                        {{c.companyName}}
                      </div>
                      <div>
                        {{c.companySortNameCn}}
                      </div>
                    </div>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item :label="$t('news.contentLabel')" class="required">
                <a-textarea
                  :rows="5"
                  :placeholder="$t('news.contentTip')" v-decorator="decorators.content"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="smallFormDiv" v-if="newsType == '业主动态'">
        <a-form :form="ownerForm" layout="vertical">
          <a-row :gutter="20">
            <a-col :span="8">
              <!--:label="$t('news.ownerForm.projectLabel')"-->
              <a-form-item  >
                <span slot="label">
                  <a-dropdown>
                            <span  @click="e => e.preventDefault()" style="margin-top: -2px">
                              {{downChoice}} <a-icon :style="{ fontSize: '11px'}" type="caret-down" /><span style="margin-left: 10px">{{ $t('key76xialaquehuanxiangmu') }}</span><span style="font-size: 14px;color: #FA6361;position: relative;top: 2px;margin-left: 5px">*</span>
                            </span>
                            <a-menu style="width: 65px" slot="overlay">
                              <a-menu-item>
                                <span @click="changeDrop(1)">{{$t('news.ownerForm.projectLabel')}}</span>
                              </a-menu-item>
                              <a-menu-item>
                                <span  @click="changeDrop(2)">{{$t('news.ownerForm.project')}}</span>
                              </a-menu-item>
                               <a-menu-item>
                                <span  @click="changeDrop(3)">{{$t('news.ownerForm.industrial')}}</span>
                              </a-menu-item>
                            </a-menu>
                  </a-dropdown>
                </span>
                <a-select v-if="choiceFlag == 1" :placeholder="CustomerChoice"
                          v-decorator="decorators.ownerProjectId"
                          showSearch
                          allowClear
                          :filterOption="false"
                          @search="searchOwnerProjectListByName"
                          :notFoundContent="null">
                  <a-icon slot="suffixIcon" type="caret-down" />
                  <div slot="dropdownRender" slot-scope="menu">
                    <v-nodes :vnodes="menu" />
                    <a-divider style="margin: 0;" />
                    <div  class="addBottomBtn" @click="openAddMansionModal">
                      <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                      <div class="addBtnText">{{$t('mansion.addMansion.addTitle')}}</div>
                    </div>
                  </div>
                  <a-select-option  v-for="m in ownerMansionList" :key="m.id" :value="m.id"><div style="display: flex;overflow: hidden;justify-content: space-between"><div style="flex: auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">{{m.name}}</div><div>{{m.citys}}</div></div></a-select-option>
                </a-select>


                <a-select v-if="choiceFlag == 2" :placeholder="CustomerChoice"
                          v-decorator="decorators.ownerProjectId"
                          showSearch
                          allowClear
                          :filterOption="false"
                          @search="searchOwnerProjectsListByName"
                          :notFoundContent="null">
                  <a-icon slot="suffixIcon" type="caret-down" />
                  <div slot="dropdownRender" slot-scope="menu">
                    <v-nodes :vnodes="menu" />
                    <a-divider style="margin: 0;" />
                    <div  class="addBottomBtn" @click="openAddProjectModal">
                      <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                      <div class="addBtnText">{{$t('news.ownerForm.addProject')}}</div>
                    </div>
                  </div>
                  <a-select-option  v-for="m in ownerProjectList" :key="m.id" :value="m.id"><div style="display: flex;overflow: hidden;justify-content: space-between"><div style="flex: auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">{{m.name}}</div><div>{{m.citys}}</div></div></a-select-option>
                </a-select>

                <a-select v-if="choiceFlag == 3" :placeholder="CustomerChoice"
                          v-decorator="decorators.ownerProjectId"
                          showSearch
                          allowClear
                          :filterOption="false"
                          @search="searchIndustrialsListByName"
                          :notFoundContent="null">
                  <a-icon slot="suffixIcon" type="caret-down" />
                  <div slot="dropdownRender" slot-scope="menu">
                    <v-nodes :vnodes="menu" />
                    <a-divider style="margin: 0;" />
                    <div  class="addBottomBtn" @click="openAddIndustrialModal">
                      <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                      <div class="addBtnText">{{$t('news.ownerForm.addIndustrial')}}</div>
                    </div>
                  </div>
                  <a-select-option  v-for="m in ownerIndustrialList" :key="m.id" :value="m.id"><div style="display: flex;overflow: hidden;justify-content: space-between"><div style="flex: auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">{{m.name}}</div><div>{{m.citys}}</div></div></a-select-option>
                </a-select>





              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('news.ownerForm.ownerLabel')">
                <a-select :placeholder="$t('news.ownerForm.ownerTip')"
                          v-decorator="decorators.ownerId"
                           showSearch
                           :filterOption="false"
                           :defaultActiveFirstOption="false"
                           :notFoundContent="null"
                           @search="initOwnerListByName"
                >
                  <a-icon slot="suffixIcon" type="caret-down" />
                  <div slot="dropdownRender" slot-scope="menu">
                    <v-nodes :vnodes="menu" />
                    <a-divider style="margin: 0;" />
                    <div class="addBottomBtn" @click="openAddProprietorModal">
                      <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                      <div class="addBtnText">{{$t('proprietor.proprietorModal.title')}}</div>
                    </div>
                  </div>
                  <a-select-option v-for="c in ownerList" :key="c.id" :value="c.id">
                    <div style="display:flex;">
                      <div style="flex:1;" class="invisible-item">
                        {{c.companyName}}
                      </div>
                      <div>
                        {{c.companySortNameCn}}
                      </div>
                    </div>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item :label="$t('news.contentLabel')" class="required">
                <a-textarea
                  :rows="5"
                  :placeholder="$t('news.contentTip')" v-decorator="decorators.content"
                />
              </a-form-item>

              <a-form-item hidden >
                <a-input v-decorator="decorators.ownerFlag"></a-input>
              </a-form-item>

            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="smallFormDiv" v-if="newsType == '租户动态'">
        <a-form :form="tenantForm" layout="vertical">
          <a-row>
            <a-col :span="16">
              <a-form-item :label="$t('news.customerId')" class="required">
                <a-select :placeholder="$t('news.customerPlaceholder')"
                          v-decorator="decorators.customerId"
                          showSearch
                          :showArrow="false"
                          :filterOption="false"
                          :value="customerValue"
                          @search="searchCustomerList"

                          :defaultActiveFirstOption="false"
                          :notFoundContent="null">
                  <a-icon slot="suffixIcon" type="caret-down" />
                  <div slot="dropdownRender" slot-scope="menu">
                    <v-nodes :vnodes="menu" />
                    <a-divider style="margin: 0;" />
                    <div class="addCustomerBtn" @click="openAddCustomerModal">
                      <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                      <div style="font-size: 12px;color: #ffffff;margin-left:4px;">{{$t('track.trackModal.addCustomer')}}</div>
                    </div>
                  </div>
                  <a-select-option v-for="d in customerList" :key="d.id" :value="d.id">
                    <div style="display:flex;">
                      <div style="flex:1;" class="invisible-item">
                        {{d.companyName}}
                      </div>
                      <div>
                        {{d.companySortNameCn}}
                      </div>
                    </div>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item :label="$t('news.contentLabel')" class="required">
                <a-textarea
                  :rows="7"
                  :placeholder="$t('news.contentTip')" v-decorator="decorators.content"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="smallFormDiv" v-if="newsType == '宏观动态'">
        <a-form :form="generalForm" layout="vertical">
          <a-row>
            <a-col :span="24">
              <a-form-item :label="$t('news.contentLabel')" class="required">
                <a-textarea
                  :rows="7"
                  :placeholder="$t('news.contentTip')" v-decorator="decorators.content"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="smallFormDiv" v-if="newsType == '人员变动'">
        <a-form :form="agentForm" layout="vertical">
          <a-row>
            <a-col :span="24">
              <a-form-item :label="$t('news.agentForm.remarksLabel')" class="required">
                <a-textarea
                  :rows="7"
                  :placeholder="$t('news.agentForm.remarksTip')" v-decorator="decorators.ownerContent"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="smallFormDiv" v-if="newsType == '住宅'">
        <a-form :form="residenceForm" layout="vertical">
          <a-row>
            <a-col :span="24">
              <a-form-item :label="$t('news.residence')" class="required">
                <a-textarea
                    :rows="7"
                    :placeholder="$t('news.residenceTips')" v-decorator="decorators.residenceContent"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="smallFormDiv" v-if="newsType == '市场洞察'">
        <a-form :form="insightsForm" layout="vertical">
          <a-row>
            <a-col :span="24">
              <a-form-item :label="$t('news.agentForm.insights')" class="required">
                <a-textarea
                  :rows="7"
                  :placeholder="$t('news.agentForm.insightsPlaceholder')" v-decorator="decorators.content"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <pt-modal :title="customerModalTitle" :visible="customerModalVisible"
                @ok="saveCustomer" @cancel="cancelAddCustomer" :width="800"
      >
        <div slot="content">
          <add-customer ref="addCustomerRef" v-model="customerModalTitle" @saveSuccess="saveCustomerSuccess"></add-customer>
        </div>
      </pt-modal>
      <pt-modal :title="$t('competePerson.addModal.title')" :visible="colleagueModalVisible"
                @ok="saveColleague" @cancel="cancelAddColleague" :width="800"
      >
        <div slot="content">
          <add-compete-person ref="competePerson" @saveSuccess="saveColleagueSuccess"></add-compete-person>
        </div>
      </pt-modal>

      <pt-modal :title="$t('mansion.addMansion.addTitle')" :visible="addMansionVisible"
                @ok="addMansion" @cancel="cancelAddMansion" :width="800"
      >
        <div slot="content">
          <quickly-add-mansion ref="addMansionRef" @saveSuccess="saveMansionSuccess"></quickly-add-mansion>
        </div>
      </pt-modal>
      <!--新增产业园-->
      <pt-modal :title="$t('news.ownerForm.addIndustrial')" :visible="addIndustrialVisible"
                @ok="addIndustrial" @cancel="cancelAddIndustrial" :width="800"
      >
        <div slot="content">
          <quickly-add-industrial ref="addIndustrialRef" @saveSuccess="saveIndustrialSuccess"></quickly-add-industrial>
        </div>
      </pt-modal>





      <pt-modal :title="$t('news.ownerForm.addProject')" :visible="addProjectVisible"
                @ok="addProject" @cancel="cancelAddProject" :width="800"
      >
        <div slot="content">
          <add-project ref="addProjectRef" @saveSuccess="saveProjectSuccess"></add-project>
        </div>
      </pt-modal>




      <pt-modal :title="proprietorModalTitle" :visible="proprietorModalVisible"
                @ok="saveProprietor" @cancel="cancelAddProprietorModal" :width="800">
        <div slot="content">
          <add-proprietor ref="addProprietor" v-model="proprietorModalTitle" @saveSuccess="saveProprietorSuccess"></add-proprietor>
        </div>
      </pt-modal>
    </div>
</template>

<script>
  import colleagueApi from '@/api/database/colleague'
  import linkmanChangeRecordsApi from '@/api/database/linkmanChangeRecords'
  import ownerApi from '@/api/database/owner'
  import projectApi, { listAllByName } from '@/api/database/projectInfo'
  import linkmanApi from '@/api/database/linkman'
  import mansionInfoApi from '@/api/database/mansion'
  import industrialApi from '@/api/database/industrial'
  import dealForm from './modal/dealForm'
  import customerApi from '@/api/mine/customer'
  import ownerMansionApi from '@/api/database/ownerMansion'
  import {findCascadingData} from '@/api/sys/datadict'
  import AddCustomer from '../../database/customer/module/addCustomer'
  import mansionApi from '@/api/database/mansion'
  import QuicklyAddMansion from '../../database/mansionData/quicklyAddMansion'
  import QuicklyAddIndustrial from '../../database/industrial/module/quicklyAddIndustrial.vue'
  import addProject from '../../database/project/module/addOrUpdate'
  import { getDatadictChildsByPath } from '@/api/sys/datadict'
  import AddCompetePerson from '../../database/competePerson/module/addCompetePerson'
  import AddProprietor from '../../database/proprietor/module/addProprietor'
  import NewsLeaseForm from './modal/newsLeaseForm'
  import Api from '@/api/database/projectInfo'
  import newsApi from "@/api/mine/news";

  export default {
    name: 'issueNews',
    components:{
      QuicklyAddIndustrial,
      NewsLeaseForm,
      AddProprietor,
      AddCompetePerson,
      dealForm,AddCustomer,addProject,
      VNodes: {
        functional: true,
        render: (h, ctx) => ctx.props.vnodes,
      },QuicklyAddMansion
    },
    props:{
      defaultRentUnit:{
        type:String,
        default:null,
      },
      defaultAreaUnit:{
        type:String,
        default:null,
      },
      showTypeRow:{
        type: Boolean,
        default: true
      },
      isNewsAmendment:{
        type:Boolean,
        default:false,
      },
      value: {
        type: Object,
        default: ()=>{return null}
      },
      city:{
        type:String,
        default:''
      },
    },
    data(){
      let _this = this;
      return  {
        queryVO:{
          text:"",//模糊匹配值
          companyId:_this.$store.getters.userInfo.companyDO.id,
        },
        proprietorModalTitle:'',
        addMansionVisible:false,
        addProjectVisible:false,
        addIndustrialVisible:false,
        ownerName:null,
        proprietorModalVisible:false,
        colleagueModalVisible:false,
        customerModalVisible: false,
        customerModalTitle:'',
        companyId:null,
        downChoice:_this.$t('news.ownerForm.projectLabel'),
        CustomerChoice: _this.$t('news.ownerForm.projectTip'),
        companyType:null,
        customerValue:undefined,
        newsType: '交易记录',
        mansionQueryText:'',
        allLinkmanList:[],
        cityDatas:[],
        choiceFlag:1,
        colleagueList:[],
        ownerList:[],
        ownerMansionList:[],
        ownerProjectList:[],
        ownerIndustrialList:[],
        colleagueLinkmanList:[],
        mansionList:[],
        allCompanyList:[],
        customerList:[],
        joinDate:undefined,
        lastDate:undefined,
        peerForm:_this.$form.createForm(_this,{}),
        ownerForm:_this.$form.createForm(_this,{}),
        tenantForm:_this.$form.createForm(_this,{}),
        generalForm:_this.$form.createForm(_this,{}),
        residenceForm:_this.$form.createForm(_this,{}),
        agentForm:_this.$form.createForm(_this,{}),
        insightsForm:_this.$form.createForm(_this,{}),
        companyName:'',
        modal:{
          visible:false,
          loading:false,
          formToken:'',
        },
        decorators:{
          content:[
            'content',{rules:[
                {required: true, message:this.$t('news.contentTip')},
                {max:1024,message:this.$t('news.contentMaxLenTip')}
              ]}
          ],
          residenceContent:[
            'content',{rules:[
                {required: true, message:this.$t('news.residenceTips')},
                {max:1024,message:this.$t('news.contentMaxLenTip')}
              ]}
          ],
          customerId:['customerId',{rules:[{required:true,message:_this.$t('news.tenantForm.tenantTip')}]}],
          colleagueId:['colleagueId',{rules:[{required:true,message:_this.$t('news.peerForm.companyTip')}]}],
          colleagueLinkmanId:['colleagueLinkmanId',{}],
          ownerId:['ownerId',{}],
          ownerProjectId:['ownerProjectId',{rules:[{required:true,message:_this.choiceFlag == 1 ? _this.$t('news.ownerForm.projectTip') : _this.$t('news.ownerForm.projectChoice')}]}],
          linkmanChangeId:['linkmanChangeId',{rules:[{required: true, message:_this.$t('news.agentForm.contactTip')}]}],
          ownerContent:['content',{rules:[
            {required:true, message:_this.$t('news.agentForm.errorInfo.remarksRequired')},
              {max:1024,message:_this.$t('news.contentMaxLenTip')}
            ]}],
          city:['city',{}],
          ownerFlag:['ownerFlag',{initialValue:0}],
        },
      }
    },
    mounted(){
      this.initForm()
      this.initMansionList()
      this.initcityData()
    },
    methods:{
      changeDrop(e){
        if(e == 1 ){
          this.choiceFlag = 1
          this.downChoice = this.$t('news.ownerForm.projectLabel');
          this.CustomerChoice = this.$t('news.ownerForm.projectTip');
          this.ownerForm.setFieldsValue({"ownerProjectId":undefined})
          this.ownerForm.setFieldsValue({"ownerFlag":0})
        }else if(e == 2){
          this.choiceFlag = 2
          this.downChoice = this.$t('news.ownerForm.project');
          this.CustomerChoice = this.$t('news.ownerForm.projectChoice');
          this.ownerForm.setFieldsValue({"ownerProjectId":undefined})
          this.ownerForm.setFieldsValue({"ownerFlag":1})
        }else{
          this.choiceFlag = 3
          this.downChoice = this.$t('news.ownerForm.industrial');
          this.CustomerChoice = this.$t('news.ownerForm.industrialChoice');
          this.ownerForm.setFieldsValue({"ownerProjectId":undefined})
          this.ownerForm.setFieldsValue({"ownerFlag":2})
        }
        console.log('e',e)

      },
      openAddMansionModal(){
        this.addMansionVisible = true;
      },
      openAddProjectModal(){
        this.addProjectVisible = true;
      },
      openAddIndustrialModal(){
        this.addIndustrialVisible = true;
      },
      cancelAddMansion(){
        this.addMansionVisible = false;
      },
      cancelAddIndustrial(){
        this.addIndustrialVisible = false;
      },
      cancelAddProject(){
        this.addProjectVisible = false;
      },
      addMansion(){
        this.$refs.addMansionRef.submit();
      },
      addIndustrial(){
        this.$refs.addIndustrialRef.submitIndustrial();
      },

      addProject(){
          this.modal.loading = true;
          this.$refs.addProjectRef.getData().then(datas=>{
            console.log(datas)
            datas.formToken = this.modal.formToken
            this.execSave(datas)

          }).catch((e)=>{
            this.modal.loading = false;
          })
      },
      execSave(datas){
        Api.save(datas).then(res=>{
          this.modal.loading = false;
          if(res.code == 1){
            this.$message.success("保存成功")
            this.saveProjectSuccess(res.data.id,res.data.name)
          }
        }).catch(()=>{
          this.modal.loading = false;
        })
      },
      saveProjectSuccess(projectId,projectName){
        let newProjectObj = {
          id:projectId,
          name:projectName
        }
        this.ownerProjectList = [];
        this.ownerProjectList.push(newProjectObj);

        this.ownerForm.setFieldsValue({
          ownerProjectId: projectId,
        });
        this.addProjectVisible = false;
      },
      saveIndustrialSuccess(industrialId,industrialName){
        let newIndustrialObj = {
          id:industrialId,
          name:industrialName
        }
        this.ownerIndustrialList = [];
        this.ownerIndustrialList.push(newIndustrialObj);

        this.ownerForm.setFieldsValue({
          ownerProjectId: industrialId,
        });
        this.addIndustrialVisible = false;
      },

      saveMansionSuccess(mansionId,mansionName){
        let newMansionObj = {
          id:mansionId,
          name:mansionName
        }
        this.ownerMansionList = [];
        this.ownerMansionList.push(newMansionObj);

        this.ownerForm.setFieldsValue({
          ownerProjectId: mansionId,
        });
        this.addMansionVisible = false;
      },




      newCompanyValidation(rule,value,cb){
        if(this.joinDate && !value){
          cb(this.$t('news.editPage.errorInfo.downIdIsNull'))
        }else{
          cb()
        }
      },
      lastDateValidator(rule,value,cb){
        if(this.joinDate){
          this.joinDate.startOf('month')
          this.lastDate.startOf('month')
          if(this.joinDate.diff(this.lastDate,'days') < 0){
            cb(this.$t('news.editPage.errorInfo.joinDateLELastDate'))
          }else{
            cb()
          }
        }else{
          cb()
        }
      },
      openAddProprietorModal(){
        this.proprietorModalVisible = true;
      },
      cancelAddProprietorModal(){
        this.proprietorModalVisible = false;
      },
      saveProprietor(){
        this.$refs.addProprietor.submit();
      },
      saveProprietorSuccess(id,name,owner){
        let newObj = {
          id:id,
          companyName:name,
          companySortNameCn: owner.companySortNameCn,
        }
        this.ownerList = [];
        this.ownerList.push(newObj);
        this.ownerForm.setFieldsValue({
          ownerId: id
        })
        this.proprietorModalVisible = false;
      },
      saveColleague(){
        this.$refs.competePerson.submit();
      },
      saveColleagueSuccess(id,name,colleague){
        let newObj = {
          id:id,
          companyName:name,
          companySortNameCn: colleague.companySortNameCn
        }
        this.colleagueList.push(newObj);

        this.peerForm.setFieldsValue({
          colleagueId : id
        });
        this.refreshLinkmanList(id);
        this.colleagueModalVisible = false;
      },
      openAddColleagueModal(){
        this.colleagueModalVisible = true;
      },
      cancelAddColleague(){
        this.colleagueModalVisible = false;
      },
      cancelAddCustomer(){
        this.customerModalVisible = false;
      },
      changeCompanyRegion(value){
        this.city = value
      },
      changeCompanyName(value){
        this.companyName = this.allLinkmanList.find(e=>{
          return e.id == value
        }).companyName
      },
      companySelect(value){
        let company = this.allCompanyList.find(e=>{return e.key == value})
        this.companyType = company.type
        this.companyId = company.id
      },
      initColleague(){
        let p = new Promise((resolve,reject)=>{
          colleagueApi.selectAll({size:0}).then(res=>{
            if(res.code == 1){
              this.colleagueList = res.data.records
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      ownerSelectById(id){
        if(id != '0'){
          let p = new Promise((resolve,reject) => {
            ownerApi.selectOne(id).then(res=>{
              if(res.code == 1){
                this.ownerList = [res.data]
                resolve()
              }else{
                reject()
              }
            })
          })
          return p
        }
      },
      async initForm(){
        if(this.value == null){
          return
        }
        let value = JSON.parse(JSON.stringify(this.value))
        this.newsType = value != null ? value.informationType : '交易记录'
        this.city = value.city
        await this.initCustomerValue(value.customerId)
        let _this = this;
        this.$nextTick(()=>{
          switch(this.newsType){
            case '同行信息':
              Promise.all([this.initColleague(),this.refreshLinkmanList(value.colleagueId)]).then(()=>{
                value.colleagueId = value.colleagueId == '0' ? undefined : value.colleagueId;
                // value.colleagueLinkmanId = value.colleagueLinkmanId == '0' ? undefined : value.colleagueLinkmanId;
                this.$nextTick(()=>{
                  this.peerForm.setFieldsValue(value)
                })
              })
              break
            case '业主动态':
              Promise.all([
                this.ownerSelectById(value.ownerId),
                this.initOwnerMansionDO(value.ownerProjectId)
              ]).then(()=>{
                if(value.ownerFlag == 0 ) {
                  _this.choiceFlag = 1
                  _this.downChoice = this.$t('news.ownerForm.projectLabel');
                }else if(value.ownerFlag == 1 ){
                  _this.choiceFlag = 2
                  _this.downChoice = this.$t('news.ownerForm.project');
                }else if(value.ownerFlag == 2 ){
                  _this.choiceFlag = 3
                  _this.downChoice = this.$t('news.ownerForm.industrial');
                }
                value.ownerId = value.ownerId == '0' ? undefined : value.ownerId;
                value.ownerProjectId = value.ownerProjectId == '0' ? undefined : value.ownerProjectId;
                this.$nextTick(()=>{
                  this.ownerForm.setFieldsValue(value)
                })
              })
              break
            case '租户动态':
              value.customerId = value.customerId == '0' ? undefined : value.customerId;
              this.tenantForm.setFieldsValue(value)
              break
            case '宏观动态':

              this.generalForm.setFieldsValue(value)
              break
            case '市场洞察':
              this.insightsForm.setFieldsValue(value)
              break
            case '住宅':
              this.residenceForm.setFieldsValue(value)
              break
            case '人员变动':
              Promise.all([this.initCompanyListByKey(value.downId),this.initLinkmanListById(value.linkmanChangeId)]).then(()=>{
                value.joinDate = this.$moment(value.joinDate)
                value.lastDate = this.$moment(value.lastDate)
                value.downId = value.downId == '~' ? undefined : value.downId;

                this.agentForm.setFieldsValue(value)
              })
              break
          }
        })
      },
      initMansionList(){
        mansionInfoApi.selectListByQuery({queryText: this.mansionQueryText}).then(res=>{
          if(res.code == 1){
            this.mansionList = res.data.records
          }
        })
      },
      initOwnerList(){
        let p = new Promise((resolve,reject)=>{
          ownerApi.selectAll({size:0}).then(res=>{
            if(res.code == 1){
              this.ownerList = res.data.records
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      initOwnerListByName(name){
        ownerApi.queryByName({name:name}).then(res=>{
          if(res.code == 1){
            this.ownerList = res.data != null ? res.data : []
          }else{
          }
        })
      },
      initcityData(){
        // let me = this.$store.getters.userInfo
        // this.city = me.companyDO.city
        getDatadictChildsByPath('system.business_key.news_setup').then(res=>{
          // this.cityDatas = res.data
          this.initCityDatas(res.data);
        })
      },
      initCityDatas(datas){
        this.cityDatas = [];
        newsApi.getUserCitys().then((res)=>{
          let citys = res.data;
          if(citys.indexOf(this.city) == -1){
            this.city = citys[0]
          }
          citys.forEach(data=>{
            datas.forEach(dictData=>{
              if(data == dictData.wordKey){
                this.cityDatas.push(dictData)
              }
            })
          })
        })
      },
      async initCustomerValue(id){
        if(id == 0){
          return
        }
        await customerApi.selectOne(id).then(res=>{
          if(res.code == 1) {
            this.customerList = [res.data]
          }
        })
      },
      initAllCompanyList(companyName){
        if(companyName == ''){
          return
        }
        let p = new Promise((resolve, reject)=>{
          linkmanChangeRecordsApi.queryByName(companyName).then(res=>{
            if(res.code == 1){
              this.allCompanyList = res.data != null ? res.data : []
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      initCompanyListByKey(key){
        if(key == '~'){
          return
        }
        let p = new Promise((resolve, reject)=>{
          linkmanChangeRecordsApi.queryByKey(key).then(res=>{
            if(res.code == 1){
              this.allCompanyList = res.data
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      initLinkmanListById(id){
        let p = new Promise((resolve,reject)=>{
          linkmanApi.selectOne(id).then(res=>{
            if(res.code == 1){
              this.allLinkmanList = [res.data]
              this.companyName = res.data.companyName
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      initAllLinkmanList(name){
        if(!name || name.trim() == ''){
          return
        }
        let queryStr = name.trim()
        let p = new Promise((resolve,reject)=>{
          linkmanApi.queryByName(queryStr).then(res=>{
            if(res.code == 1){
              this.allLinkmanList = res.data
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      openAddCustomerModal(){
        this.customerModalVisible = true;
      },
      refreshLinkmanList(colleagueId){
        let p = new Promise((resolve,reject)=>{
          linkmanApi.listByTypeAndCompanyId(2,colleagueId).then(res=>{
            if(res.code == 1){
              this.colleagueLinkmanList = res.data
              resolve()
            }else{
              reject()
            }
          })
        })
      },
      initOwnerMansionDO(id){
        if(id != '0') {
          let p = new Promise((resolve, reject) => {
            if(this.value.ownerFlag == 0 ){
              mansionApi.selectOne(id,2).then(res => {
                if (res.code == 1) {
                  this.ownerMansionList = [res.data];
                  resolve()
                } else {
                  reject()
                }
              })
            }else if(this.value.ownerFlag == 1 ){
              projectApi.queryById(id).then(res => {
                if (res.code == 1) {
                  this.ownerProjectList = [res.data]
                  resolve()
                }else{
                  reject()
                }
              })
            }else if(this.value.ownerFlag == 2 ){
              industrialApi.queryById(id).then(res => {
                if (res.code == 1) {
                  this.ownerIndustrialList = [res.data]
                  resolve()
                }else{
                  reject()
                }
              })
            }
          })
          return p
        }
      },

      //大廈
      searchOwnerProjectListByName(name){
        if(name == null || name == ''){
          return
        }
        mansionApi.listAll({queryText: name}).then(res=>{
          if(res.code == 1){
            this.ownerMansionList = res.data
          }
        })
      },

      //項目
      searchOwnerProjectsListByName(name){
        if(name == null || name == ''){
          return
        }
        let projectInfoDO = {}
        projectInfoDO.name = name
        projectApi.listAllByName(projectInfoDO).then(res=>{
          if(res.code == 1){
            console.log('projectInfoDO',res.data)
            this.ownerProjectList = res.data
          }
        })
      },

      //項目
      searchIndustrialsListByName(name){
        if(name == null || name == ''){
          return
        }
        industrialApi.listAllByName(name).then(res=>{
          if(res.code == 1){
            console.log('projectInfoDO',res.data)
            this.ownerIndustrialList = res.data
          }
        })
      },
      refreshOwnerProjectList(ownerId){
        if(ownerId == '0' || ownerId == '~'){
          return
        }

        this.ownerForm.setFieldsValue({ownerProjectId:ownerId})
        let p = new Promise((resolve, reject)=>{
          ownerMansionApi.selectMansionProjectByOwnerId(ownerId).then(res=>{
            if(res.code == 1){
              this.ownerMansionList = res.data
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      searchCustomerList(customerNameQuery){
        customerApi.queryByName({name:customerNameQuery}).then(res=>{
          if(res.code == 1) {
            this.customerList = res.data
          }
        })
      },
      getFormData(){
        let this_ = this
        let newsDO = Object.assign({},this.value)
        switch(this.newsType){
          case '交易记录':
            let curNewsDo = this.$refs.dealFormRef.submit();
            if(curNewsDo){
              Object.assign(newsDO,curNewsDo);
              // newsDO = curNewsDo;
              newsDO.agent = curNewsDo.agent;
              newsDO.comment = curNewsDo.comment;
              newsDO.remark = curNewsDo.remark;
              console.log("保存前获取的数据",curNewsDo)
            }else{
              newsDO = null;
            }
            break
          case '同行信息':
            this.peerForm.validateFieldsAndScroll((err,values) => {
              if (!err) {
                Object.assign(newsDO , this.peerForm.getFieldsValue())
                // let colleague = this.colleagueList.find(e=>{return e.id == newsDO.colleagueId})
                // let displayContent = ''
                // if(colleague){
                //   displayContent += colleague.companySortNameCn
                // }
                // displayContent += ',' + newsDO.content
                // newsDO.displayContent = displayContent
              }else{
                newsDO = null;
              }
            })
            break
          case '业主动态':
            this.ownerForm.validateFieldsAndScroll((err,values) => {
              if (!err) {
                Object.assign(newsDO , this.ownerForm.getFieldsValue())
                // let owner = this.ownerList.find(e=>{ return e.id == newsDO.ownerId})
                // let mansion = this.ownerMansionList.find(e=>{ return e.id == newsDO.ownerProjectId})
                // let displayContent = mansion.name
                // if(owner){
                //   displayContent += ',' + owner.companySortNameCn
                // }
                // displayContent += ',' + newsDO.content
                // newsDO.displayContent = displayContent
              }else{
                newsDO = null;
              }
            })
            break
          case '租户动态':
            this.tenantForm.validateFieldsAndScroll((err,values) => {
              if (!err) {
                Object.assign(newsDO , this.tenantForm.getFieldsValue());
                // let tenant = this_.customerList.find(e=>{return e.id == newsDO.customerId})
                // let displayContent = tenant.companySortNameCn + ',' + newsDO.content
                // newsDO.displayContent = displayContent
              }else{
                newsDO = null;
              }
            })
            break
          case '宏观动态':
            this.generalForm.validateFieldsAndScroll((err,values) => {
              if (!err) {
                Object.assign(newsDO , this.generalForm.getFieldsValue());
                // newsDO.displayContent = newsDO.content
              }else{
                newsDO = null;
              }
            })
            break
          case '人员变动':
            this.agentForm.validateFieldsAndScroll((err,values) => {
              if (!err) {
                Object.assign(newsDO , this_.agentForm.getFieldsValue())
                // let displayContent = newsDO.content
                // newsDO.displayContent = displayContent
              }else{
                newsDO = null;
              }
            })
            break
          case '市场洞察':
            this.insightsForm.validateFieldsAndScroll((err,values) => {
              if (!err) {
                Object.assign(newsDO , this_.insightsForm.getFieldsValue())
                // let displayContent = newsDO.content
                // newsDO.displayContent = displayContent
              }else{
                newsDO = null;
              }
            })
            break
          case '住宅':
            this.residenceForm.validateFieldsAndScroll((err,values) => {
              if (!err) {
                Object.assign(newsDO , this_.residenceForm.getFieldsValue())
                // let displayContent = newsDO.content
                // newsDO.displayContent = displayContent
              }else{
                newsDO = null;
              }
            })
            break
          default:
            break
        }
        if(newsDO){
          newsDO.informationType = this.newsType
          newsDO.city = this.city
          return newsDO;
        }else{
          return false;
        }
      },
      switchNewsType(type){
        this.newsType = type;
        if(type=='租户动态' && this.customerList.length == 0){
        }else if(type=='同行信息'){
          this.initColleague()
        }else if(type=='业主动态'){
        }else if(type=='人员变动'){
          this.initAllCompanyList(null)
          this.initAllLinkmanList()
        }
      },
      saveCustomer(){
        this.$refs.addCustomerRef.submit()
      },
      saveCustomerSuccess(id,name,customer){
        this.customerList = [];
        let customerDO = {
          id:id,
          companyName:name,
          companySortNameCn: customer.companySortNameCn
        }
        this.customerList.push(customerDO);

        this.tenantForm.setFieldsValue({
          customerId: id
        })
        this.customerModalVisible = false;
      }
    },
    watch:{
      value(){
        this.initForm()
      }
    }
  }
</script>

<style scoped lang="less">
  .addBottomBtn{
    background: #3B2E26;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 30px;
    .addIcon{
      color: #ffffff;
      font-size: 12px;
    }
    .addBtnText{
      font-size: 12px;
      color: #ffffff;
      margin-left:4px;
    }
  }
  .addCustomerBtn{
    background: #3B2E26;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 30px;
    .addIcon{
      color: #ffffff;
      font-size: 12px;
    }
  }
  .newsTypeRow{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    user-select: none;
    position: relative;
    border-bottom: 1px solid #E1E1E1;
    .lastItem{
      margin-right: 20px;
    }
    .typeAIcon{
      font-size:20px;
      color: #FFFFFF;
    }
    .newsTypeItem{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      height: 82px;
      .typeIcon{
        font-size: 40px;
        color: #BCBCBC;
      }
      .newsTypeText{
        font-size: 12px;
        color: #999999;
        margin-top: 10px;
        margin-bottom: 10px;
      }
      .activeTypeLine{
        width: 100%;
        height: 2px;
        background: transparent;
      }
    }
    .newsTypeItem:hover{
      .typeIcon{
        color: #FABE00;
      }
      .newsTypeText{
        color: #333333;
      }
    }
    .newsTypeItemActive{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      height: 82px;
      .typeIcon{
        font-size: 40px;
        color: #FABE00;
      }
      .newsTypeText{
        font-size: 12px;
        color: #333333;
        margin-top: 10px;
        margin-bottom: 10px;
      }
      .activeTypeLine{
        width: 100%;
        height: 2px;
        background: #FABE00;
      }
    }
    .citySwitch{
      display: flex;
      flex-direction: row;
      justify-content: center;
      position: absolute;
      right: 0;
      bottom: 0;
      align-items: center;
      margin-bottom: 12px;
      margin-right: 4px;
      cursor: pointer;
      .cityIcon{
        font-size: 16px;
        color: #BCBCBC;
        margin-right: 4px;
      }
      .cityText{
        font-size: 12px;
        color: #333333;
      }
    }
  }
  .formDiv{
    border-radius: 0 0 4px 4px;
    padding-bottom: 20px;
  }
  .smallFormDiv{
    background: rgba(248,249,251,0.62);
    border-radius: 0 0 4px 4px;
    padding: 20px 20px 0px 20px;
  }
  .ant-select-dropdown-content{
    /deep/.invisible-item{
      display:initial !important;
    }
  }
  /deep/.invisible-item{
    display:none;
  }

</style>